import { Sheet, PouchColorLegend, Pouch, POUCH_COLORS, Group } from '../types';
import { SheetStorage } from '../utils/StorageUtils';
import { isInMuteGroup } from './GroupLogic';
import { calculateReferencedGroupCount } from './StatisticsLogic';
import React from 'react';

// 色の合計を計算
export const calculateColorTotal = (pouches: Pouch[], colorId: string, groups: Group[] = []): number => {
  return pouches
    .filter(p => p.color === colorId && !isInMuteGroup(p.id, groups))
    .reduce((total, p) => {
      const value = p.multiplier < 0 
        ? p.value / Math.abs(p.multiplier) 
        : p.value * p.multiplier;
      return total + value;
    }, 0);
};

// 色のカウントを計算
export const calculateColorCount = (pouches: Pouch[], colorId: string, groups: Group[] = []): number => {
  return pouches
    .filter(p => p.color === colorId && !isInMuteGroup(p.id, groups))
    .reduce((count, p) => {
      if (p.isGroupTotalPouch && p.referencedGroupId) {
        const refGroupCount = calculateReferencedGroupCount(
          p.referencedGroupId, pouches, groups, p.id
        );
        const gtpMult = p.multiplier < 0
          ? 1 / Math.abs(p.multiplier)
          : p.multiplier;
        return count + refGroupCount * gtpMult;
      }
      const multiplierValue = p.multiplier < 0 
        ? 1 / Math.abs(p.multiplier) 
        : p.multiplier;
      return count + multiplierValue;
    }, 0);
};

// 凡例を更新
export const updateColorLegend = async (
  sheet: Partial<Sheet> & { id: string; colorLegends?: PouchColorLegend[] },
  colorId: string,
  legend: string,
  onUpdateActiveSheet: (pouches: Pouch[] | null, groups: Group[] | null, isCritical?: boolean, saveToDb?: boolean, sheetParams?: Partial<Sheet>) => void,
  dispatch?: React.Dispatch<any>
): Promise<void> => {
  try {
    // 既存の凡例を更新または新規作成
    const updatedLegends = sheet.colorLegends?.map(l => 
      l.colorId === colorId ? { ...l, legend } : l
    ) || [];

    // onUpdateActiveSheetを呼び出して更新する
    // 第1引数・第2引数: パウチとグループはnull（変更しない）
    // 第3引数: isCritical = true（重要な更新）
    // 第4引数: saveToDb = true（DBに保存する）
    // 第5引数: sheetParams = { colorLegends: updatedLegends }（更新するシートパラメータ）
    onUpdateActiveSheet(null, null, true, true, { colorLegends: updatedLegends });
  } catch (error) {
    console.error('凡例の更新に失敗しました:', error);
  }
}; 